import { TuiRoot } from '@taiga-ui/core';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { SessionContextStore } from './core/stores/session-context.store';
import { map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterOutlet, TuiRoot],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected readonly title = signal('eai-share');

  private readonly route = inject(ActivatedRoute);
  private readonly store = inject(SessionContextStore);

  constructor() {
    this.route.queryParamMap
      .pipe(
        map((params) => ({
          alias: params.get('s'),
        })),
        takeUntilDestroyed(),
      )
      .subscribe((ctx) => this.store.setAlias(ctx.alias!));
  }
}
